import { render, staticRenderFns } from "./AddCommodity.vue?vue&type=template&id=28542920&"
import script from "./AddCommodity.vue?vue&type=script&lang=js&"
export * from "./AddCommodity.vue?vue&type=script&lang=js&"
import style0 from "./AddCommodity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports